import { getListDataFunctionFactory } from '../../../modules/getListDataFunctionFactory'
import type { IContactRole } from '~/types/contact/models'
import type { TEntityId } from '~/types/models'

const companyContactRoleListData = undefined as unknown as IContactRole[]

export const getCompanyContactRoleListData = getListDataFunctionFactory<
  IContactRole[]
>({
  listData: companyContactRoleListData,
  storageKey: 'companycontactroles',
  getStartingListData: getStartingCompanyContactRoleListData,
})

export function _getCCRDataById(
  id: TEntityId,
  list: IContactRole[]
): IContactRole {
  if (!list) {
    throw new Error(`_getCCRDataById called with undefined/null list`)
  }
  const contactRole = list.find((cr: IContactRole) => cr.id === id)
  if (!contactRole) {
    throw new Error(`Can't find companyContactRole '${id}'`)
  }
  return contactRole
}

export async function getCompanyContactRoleDataById(
  id: TEntityId
): Promise<IContactRole> {
  const list: IContactRole[] = await getCompanyContactRoleListData()
  return _getCCRDataById(id, list)
}

export async function getCompanyContactRoleDataByLabel(
  label: string
): Promise<IContactRole> {
  const list: IContactRole[] = await getCompanyContactRoleListData()
  if (!list) {
    throw new Error(`getCompanyContactRoleListData returned undefined/null`)
  }
  const c = list.find(
    (companyContactRole) => companyContactRole.label === label
  )
  if (!c) {
    throw new Error(`Can't find companyContactRole '${label}'`)
  }
  return c
}

export async function getStartingCompanyContactRoleListData(): Promise<
  IContactRole[]
> {
  return [
    {
      id: 'XXCCR0001',
      hrid: 'XXCCR0001',
      label: 'Billing',
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXCCR0002',
      hrid: 'XXCCR0002',
      label: 'Engineer',
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXCCR0003',
      hrid: 'XXCCR0003',
      label: 'Liaison',
      canBeDeleted: true,
    },
    {
      id: 'XXCCR0004',
      hrid: 'XXCCR0004',
      label: 'Project Manager',
      version: '1',
      canBeDeleted: true,
    },
    { id: 'XXCCR0005', hrid: 'XXCCR0005', label: 'Sales', canBeDeleted: true },
    {
      id: 'XXCCR0006',
      hrid: 'XXCCR0006',
      label: 'Support',
      version: '1',
      canBeDeleted: true,
    },
  ]
}
